import { cn } from "@/lib/utils";

export function AwardIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-11 w-15", className)}
      viewBox="0 0 44 60"
      {...props}
    >
      <path
        d="M37.1848 1.01906C37.0521 0.817882 36.8242 0.696289 36.5797 0.696289H25.6721C25.3886 0.696289 25.1313 0.859417 25.0149 1.11287L20.9909 9.88184C20.9064 10.0662 20.9064 10.2771 20.9909 10.4615L24.5528 18.2236C24.6691 18.4771 24.9263 18.6402 25.21 18.6402H28.9937C29.2772 18.6402 29.5345 18.4771 29.6508 18.2236L37.2369 1.69248C37.3372 1.47388 37.3176 1.22033 37.1848 1.01906Z"
        fill="#D62D2D"
      />
      <path
        d="M22.55 6.48438L20.9909 9.8819C20.9064 10.0662 20.9064 10.2772 20.9909 10.4615L24.5528 18.2237C24.6691 18.4771 24.9263 18.6402 25.21 18.6402H28.1281L22.55 6.48438Z"
        fill="#9E1219"
      />
      <path
        d="M18.9202 19.9053C18.9202 21.3823 20.1459 22.5839 21.6525 22.5839C23.1591 22.5839 24.3849 21.3823 24.3849 19.9053C24.3849 18.4282 23.1592 17.2266 21.6525 17.2266C20.1459 17.2266 18.9202 18.4283 18.9202 19.9053ZM20.3639 19.9042C20.3639 19.2061 20.9431 18.6382 21.6551 18.6382C22.3671 18.6382 22.9464 19.2061 22.9464 19.9042C22.9464 20.6022 22.3671 21.17 21.6551 21.17C20.9431 21.17 20.3639 20.6022 20.3639 19.9042Z"
        fill="#FFA035"
      />
      <path
        d="M25.8713 17.644L18.2854 1.11287C18.169 0.859417 17.9117 0.696289 17.6282 0.696289H6.72059C6.47607 0.696289 6.24828 0.817882 6.1155 1.01906C5.98273 1.22033 5.96313 1.47388 6.06343 1.69248L13.6494 18.2236C13.7658 18.4771 14.023 18.6402 14.3066 18.6402H25.2142C25.4587 18.6402 25.6865 18.5187 25.8193 18.3174C25.9519 18.116 25.9716 17.8625 25.8713 17.644Z"
        fill="#FF3D43"
      />
      <path
        d="M22.9412 18.6402H25.2111C25.4556 18.6402 25.6834 18.5187 25.8162 18.3174C25.9489 18.1161 25.9685 17.8626 25.8682 17.644L18.2823 1.11287C18.166 0.859417 17.9087 0.696289 17.6252 0.696289H14.707L22.9412 18.6402Z"
        fill="#D72E2E"
      />
      <path
        d="M21.669 21.1719C13.9284 21.1719 7.63095 27.3454 7.63095 34.9337C7.63095 42.522 13.9284 48.6955 21.669 48.6955C29.4096 48.6955 35.7071 42.522 35.7071 34.9337C35.7071 27.3454 29.4096 21.1719 21.669 21.1719Z"
        fill="#FFC850"
      />
      <path
        d="M21.6746 21.1719C21.1068 21.1719 20.5471 21.206 19.9969 21.2706C26.9494 22.086 32.3573 27.9019 32.3573 34.9338C32.3573 41.9656 26.9494 47.7815 19.9969 48.597C20.5472 48.6615 21.1068 48.6956 21.6746 48.6956C29.4152 48.6956 35.7126 42.522 35.7126 34.9338C35.7126 27.3454 29.4152 21.1719 21.6746 21.1719Z"
        fill="#F4B70C"
      />
      <path
        d="M21.6733 24.9551C16.0605 24.9551 11.494 29.4316 11.494 34.934C11.494 40.4365 16.0604 44.913 21.6733 44.913C27.2862 44.913 31.8526 40.4365 31.8526 34.934C31.8526 29.4316 27.2861 24.9551 21.6733 24.9551Z"
        fill="#FFF5CF"
      />
      <path
        d="M21.6724 24.9551C21.1361 24.9551 20.6096 24.9962 20.0955 25.075C24.9621 25.8202 28.6977 29.9573 28.6977 34.934C28.6977 39.9108 24.9621 44.0479 20.0955 44.7931C20.6096 44.8719 21.1362 44.913 21.6724 44.913C27.2853 44.913 31.8517 40.4365 31.8517 34.934C31.8517 29.4316 27.2853 24.9551 21.6724 24.9551Z"
        fill="#FFECA1"
      />
      <path
        d="M27.4454 34.5858C27.8918 34.1594 28.0492 33.5335 27.8567 32.9524C27.6641 32.3714 27.1614 31.9558 26.5446 31.868L24.2811 31.5455C24.2211 31.537 24.1693 31.5 24.1425 31.4467L23.1303 29.4361C22.8544 28.8882 22.2959 28.5479 21.6728 28.5479C21.6727 28.5479 21.6728 28.5479 21.6727 28.5479C21.0495 28.5479 20.491 28.8882 20.2151 29.4361L19.2029 31.4468C19.1761 31.5001 19.1243 31.537 19.0643 31.5456L16.8009 31.868C16.1841 31.9558 15.6814 32.3713 15.4888 32.9524C15.2962 33.5334 15.4537 34.1593 15.9001 34.5858L17.5379 36.1509C17.5813 36.1925 17.6011 36.2522 17.5908 36.3108L17.2042 38.5206C17.0988 39.1227 17.3466 39.72 17.8508 40.0791C18.1358 40.282 18.4691 40.3851 18.8047 40.3851C19.0629 40.3851 19.3227 40.324 19.5626 40.2004L21.587 39.157C21.6407 39.1293 21.7048 39.1293 21.7584 39.157L23.7828 40.2004C24.3344 40.4846 24.9903 40.4382 25.4945 40.0791C25.9987 39.72 26.2465 39.1228 26.1411 38.5206L25.7545 36.3107C25.7443 36.2522 25.7641 36.1925 25.8075 36.1509L27.4454 34.5858Z"
        fill="#FFA035"
      />
      <path
        d="M27.4445 34.586C27.8908 34.1595 28.0483 33.5336 27.8558 32.9525C27.6631 32.3715 27.1605 31.956 26.5437 31.8681L26.4344 31.8525L23.1316 34.9667C22.9183 35.1705 22.8209 35.4641 22.8714 35.7518L23.6311 40.1227L23.7821 40.2005C24.3336 40.4848 24.9896 40.4383 25.4938 40.0792C25.998 39.7201 26.2457 39.1229 26.1403 38.5207L25.7537 36.3109C25.7436 36.2523 25.7633 36.1926 25.8068 36.151L27.4445 34.586Z"
        fill="#F78819"
      />
      <path
        d="M31.1127 18.6403H12.1952C11.7973 18.6403 11.4747 18.324 11.4747 17.9339C11.4747 17.5438 11.7973 17.2275 12.1952 17.2275H31.1127C31.5107 17.2275 31.8332 17.5438 31.8332 17.9339C31.8332 18.324 31.5106 18.6403 31.1127 18.6403Z"
        fill="#FFC850"
      />
    </svg>
  );
}
